module.exports = __webpack_public_path__ + "img/smart-pharm.7ffd22ba.jpg";